import './OverridePanel.scss';
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { useMiwiStore } from '../../../store';
import { useTranslation } from 'react-i18next';
import stopIconPath from '@icons/system-stop-large.svg';
import playIconPath from '@icons/system-play-large-white.svg';
import pauseIconPath from '@icons/system-pause-large.svg';
import { DeviceType } from '@org-avp/device-models';
import { useNavigate } from 'react-router';

const OverridePanel = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { overrideMediaUrl, overrideMedia, overrideDeviceType, overrideLoading, controlMedia2D, controlMedia, controlMedia3D} = useMiwiStore();   
    const [isPaused, setIsPaused] = useState<boolean>(false);

    const [isVisible, setIsVisible] = useState<boolean>(false);

    useEffect(() => {
        if (overrideMediaUrl !== '') {
            setIsPaused(false);
        }
        setIsVisible(overrideMediaUrl !== '');
    }, [overrideMediaUrl]);

    const stopMedia = async () => {
        if (overrideDeviceType === DeviceType.CHROMEBOX) {
            await controlMedia2D('SKIP')
        } else if (overrideDeviceType === DeviceType.AVE) {
            await controlMedia3D('STOP')
        } else {
            await controlMedia('SKIP')
        }
        setIsPaused(false);
    };

    const resumeMedia = async () => {
        if (overrideDeviceType === DeviceType.CHROMEBOX) {
            await controlMedia2D('PLAY')
        } else if (overrideDeviceType === DeviceType.AVE) {
            await controlMedia3D('PLAY')
        } else {
            await controlMedia('PLAY')
        }
        setIsPaused(!isPaused);
    };

    const pauseMedia = async () => {
        if (overrideDeviceType === DeviceType.CHROMEBOX) {
            await controlMedia2D('PAUSE')
        } else if (overrideDeviceType === DeviceType.AVE) {
            await controlMedia3D('PAUSE')
        } else {
            await controlMedia('PAUSE')
        }
        setIsPaused(!isPaused);
    };

    const pauseResumeAction = () => {
        if (!isPaused) {
            pauseMedia();
        } else {
            resumeMedia();
        }
    };

    const goToMedia = data => {
        const url = `/${data.type}s/${data.uuid}`;
        navigate(url);
    };

    const classes = classnames('b-override-panel', {
        'is-hidden': !isVisible,
        'is-loading': overrideLoading
    });

    const data = overrideMedia;

    if (data) {
        return (
            <div className={classes}>
                <div className="thumbnail">
                    <img
                        src={data.thumbnail}
                        alt="thumb"
                        className="image"
                    />
                </div>
                <div className="control-icon">
                    {data.type === 'video' ? (
                        <img
                            src={isPaused ? playIconPath : pauseIconPath}
                            alt="control icon"
                            className="play"
                            onClick={() => pauseResumeAction()}
                        />
                    ) : (
                        <img
                            src={stopIconPath}
                            alt="stop icon"
                            className="stop-left"
                            onClick={stopMedia}
                        />
                    )}
                </div>
                {data.type !== 'image' ? (
                    <div className="control-icon">
                        <img
                            src={stopIconPath}
                            alt="stop icon"
                            className="stop-left"
                            onClick={stopMedia}
                        />
                    </div>
                ) : null}
                <div className="info">
                    <p className="title">
                        {data.title}{' '}
                        {data.type === 'video'
                            ? ` / ${data.duration} Sec`
                            : null}
                    </p>
                </div>
                <div className="link">
                    <p onClick={() => goToMedia(data)} className="to">
                        {t('to_media')}
                        <span className="arrow"> &gt; </span>
                    </p>
                </div>
            </div>
        );
    }
    return '';
};

export default OverridePanel;